



export const ComoParticipar = () => {

    return (
        <div>
            
            <h1>Como Participar</h1>
            
            
        </div>



    )
}